import script from "./RecentDocuments.vue?vue&type=script&setup=true&lang=ts"
export * from "./RecentDocuments.vue?vue&type=script&setup=true&lang=ts"

import "./RecentDocuments.vue?vue&type=style&index=0&id=2bc11d19&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2bc11d19"]])

export default __exports__